type AuthSplashProps = {
  readonly label: string;
  readonly detail?: string;
  readonly tone?: 'pending' | 'error';
};

export function AuthSplash({ label, detail, tone = 'pending' }: AuthSplashProps) {
  return (
    <div className={`auth-splash auth-splash--${tone} sn-section-beige`}>
      <div className="auth-splash-inner">
        <div className="auth-splash-mark">
          <img src="/assets/logomark-blue.svg" alt="" aria-hidden="true" />
        </div>
        <div className="auth-splash-eyebrow">{label}</div>
        {detail && <p className="auth-splash-detail">{detail}</p>}
      </div>
    </div>
  );
}
